module.exports = __webpack_public_path__ + "img/home-header.bcc017b2.jpg";